<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('payList.payNo')" class="mb-0">
							<el-input size="small" v-model="from.order_no" ></el-input>
						</el-form-item>
					
						<el-form-item :label="$t('payList.payType')" class="mb-0">
							<el-select v-model="from.type" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('payList.payTypeStr.1')" :value="1"></el-option>
								<el-option :label="$t('payList.payTypeStr.2')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column align="center" prop="id"  :label="$t('payList.id')" width="60">
				</el-table-column>
				
				<el-table-column align="center" prop="order_no" :label="$t('payList.payNo')">
				</el-table-column>

				<el-table-column align="center" prop="uid" :label="$t('payList.uid')">
				</el-table-column>

               	<el-table-column align="center" prop="type" width="100" :label="$t('payList.payType')">
                    <template slot-scope="scope">
						<span v-if="scope.row.type == 1" class="text-success">{{$t('payList.payTypeStr.1') }} {{scope.row.type_name}}</span>
						<span v-if="scope.row.type == 2" class="text-danger">{{$t('payList.payTypeStr.2') }} {{scope.row.type_name}}</span>
					</template>
				</el-table-column>

                <el-table-column align="center"  prop="money" :label="$t('payList.money')">
                    <template slot-scope="scope">
						<span class="text_chengse">{{scope.row.money}}</span>
					</template>
				</el-table-column>
                <el-table-column align="center"  prop="balance" :label="$t('payList.balance')">
                    <template slot-scope="scope">
						<span class="text_chengse">{{scope.row.balance}}</span>
					</template>
				</el-table-column>
               
                <el-table-column align="center" prop="remark" :label="$t('payList.remark')">
                    <template slot-scope="scope">
									<div v-if="scope.row.remark.length > 10">
										{{ scope.row.remark.substring(0, 10) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.remark)">{{$t('system.look')}}</el-button>
									</div>
									<div v-else>
										<div v-if="scope.row.remark.length > 0">{{ scope.row.remark }}</div>
										<div v-else> -- </div>
									</div>
								</template>
				</el-table-column>

				<el-table-column align="center" width="180" prop="create_time" :label="$t('layout.createTime')">
				</el-table-column>
				
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>


        <el-dialog :close-on-click-modal="false" :width="layout.is_phone?'90%':'80%'" :append-to-body="true"  :visible.sync="dialogTitleVisible" :title="$t('payList.msgTitle')">
			<p>{{ fullTitle }}</p>
		</el-dialog>


	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
                dialogTitleVisible: false,
				fullTitle: '',

				createModel: false,
				editIndex: -1,
				
				//搜索數据
				from: {
					order_no: '',
					type:-1,
					time:[],
				},
				auth_val: 'Account',

                type: 7,

				preUrl: "user/payList", //列表地址
				agentData:[],
				tableData: [],
				form: {},
				
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['agent']);
		},
		methods: {
              // 顯示完整標題内容
			showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			//提交
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {

				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 1;
			
				if (!isJPG) {
				  this.$message.error(this.$t('message.info_err'));
				}
				if (!isLt2M) {
				  this.$message.error(this.$t('message.img_max_err'));
				}
				return isJPG && isLt2M;

			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					order_no: '',
					type:-1,
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
